import React from "react";

import PageBreadcrumb from "../../../Common/UIComponents/PageBreadcrumb";
import PaymentPendingBanner from "../../../grace-period/components/PaymentPendingBanner";
import { getSupplyPickupBreadcrumbTitle } from "../../Common/utils";
import CreateEditContent from "./CreateEditContent";

import "./CreateEditSupply.css";

const SUPPLY_PICKUP_PARENT_LABEL = "Schedules";

export default function CreateEditSupply({
  requestData,
  returnToMainPage,
  onCreateSuccess,
}) {
  const handleBack = () => returnToMainPage("1");
  const breadcrumbTitle = getSupplyPickupBreadcrumbTitle(requestData);

  return (
    <div className="CreateEditSupplyContainer">
      <PageBreadcrumb
        items={[
          { label: SUPPLY_PICKUP_PARENT_LABEL },
          { label: breadcrumbTitle },
        ]}
        onBack={handleBack}
        showClose
        onClose={handleBack}
        variant="bordered"
      />
      <PaymentPendingBanner />
      <CreateEditContent
        returnToMainPage={returnToMainPage}
        onCreateSuccess={onCreateSuccess}
        requestData={requestData}
      />
    </div>
  );
}
